import api from "./client";

export const getProperties = (params) => api.get("/properties", { params });
export const getProperty = (propertyId) => api.get(`/properties/${propertyId}`);
export const createProperty = (data) => api.post("/properties", data);
export const updateProperty = (propertyId, data) => api.patch(`/properties/${propertyId}`, data);
export const deleteProperty = (propertyId) => api.delete(`/properties/${propertyId}`);
// Each id is handled on its own; properties any option, quote or booking still
// references come back in `skipped` with the reason. dry_run previews only.
export const bulkDeleteProperties = (propertyIds, { supplierId, dryRun = false } = {}) =>
  api.post("/properties/bulk-delete", { property_ids: propertyIds, supplier_id: supplierId || null, dry_run: dryRun });
// { blockers: { "PROP-x": { linked_ids, reason } } } for ids that any option,
// quote or booking (any status) references; those cannot be deleted.
export const getPropertyDeleteBlockers = (propertyIds) =>
  api.get("/properties/delete-blockers", { params: { property_ids: propertyIds.join(",") } });
export const verifyProperty = (propertyId) => api.post(`/properties/${propertyId}/verify`);
export const scrapeListingUrl = (url, autoSave = false, supplierId = null) =>
  api.post("/properties/scrape-url", { url, auto_save: autoSave, ...(supplierId ? { supplier_id: supplierId } : {}) }, { timeout: 180000 });
export const getPropertyPhotos = (propertyId) => api.get(`/properties/${propertyId}/photos`);
// Photo numbers (`n`) come from getPropertyPhotos; Drive files go to the Drive bin.
export const deletePropertyPhotos = (propertyId, numbers) => {
  const params = new URLSearchParams();
  numbers.forEach((n) => params.append("n", String(n)));
  return api.delete(`/properties/${propertyId}/photos?${params.toString()}`);
};
export const reorderPropertyPhotos = (propertyId, order) => api.put(`/properties/${propertyId}/photos/order`, { order });
export const uploadPropertyPhotosToDrive = (propertyId) => api.post(`/properties/${propertyId}/upload-photos`);
export const createPropertyDriveFolder = (propertyId) => api.post(`/properties/${propertyId}/create-drive-folder`);
export const uploadPropertyPhotoFiles = (propertyId, files) => {
  const formData = new FormData();
  files.forEach(file => formData.append('files', file));
  return api.post(`/properties/${propertyId}/upload-photo-files`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 240000,
  });
};

export const uploadPropertyPhotoFile = (propertyId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/properties/${propertyId}/upload-photo-file`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 10000, // 10s timeout for queueing only
  });
};

export const getPhotoUploadJobStatus = (propertyId, jobId) =>
  api.get(`/properties/${propertyId}/photo-upload-jobs/${jobId}`);
export const syncPropertyIcal = (propertyId) => api.post(`/properties/${propertyId}/ical/sync`);
// Re-read the supplier's channel manager (Guesty, Smoobu...): rates, calendar, new listings.
export const syncPropertyChannelManager = (propertyId) =>
  api.post(`/properties/${propertyId}/channel-manager/sync`);
// Per-user "recently viewed / created" properties (ISS-5782a928).
export const markPropertyViewed = (propertyId, action = "viewed") =>
  api.post("/property-views", { property_id: propertyId, action });
export const getMyRecentProperties = (limit = 12) =>
  api.get("/property-views/recent", { params: { limit } });
